module.exports = __webpack_public_path__ + "static/media/alishan_web.c245585d.png";